const i18nLanguage = 'i18nLanguage'

function defaultLocale() {
  //判断浏览器的首选语言
  if (navigator.language.indexOf('en') >= 0) {
    return 'en'
  }
  return 'cn'
}
// 语言选择
function setLang(value) {
  if (!value) {
    value = defaultLocale()
  }
  localStorage.setItem(i18nLanguage, value)
}

function getLang() {
  return localStorage.getItem(i18nLanguage) || defaultLocale()
}

export { i18nLanguage, setLang, getLang }
